export default `<?xml version="1.0" standalone="yes"?>
<?mso-application progid="Word.Document"?>
<pkg:package xmlns:pkg="http://schemas.microsoft.com/office/2006/xmlPackage">
  <pkg:part pkg:name="/_rels/.rels" pkg:contentType="application/vnd.openxmlformats-package.relationships+xml" pkg:padding="512">
    <pkg:xmlData>
      <Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">
        <Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument" Target="word/document.xml" />
      </Relationships>
    </pkg:xmlData>
  </pkg:part>
  <pkg:part pkg:name="/word/document.xml" pkg:contentType="application/vnd.openxmlformats-officedocument.wordprocessingml.document.main+xml">
    <pkg:xmlData>
      <w:document xmlns:wpc="http://schemas.microsoft.com/office/word/2010/wordprocessingCanvas" xmlns:cx="http://schemas.microsoft.com/office/drawing/2014/chartex" xmlns:cx1="http://schemas.microsoft.com/office/drawing/2015/9/8/chartex" xmlns:cx2="http://schemas.microsoft.com/office/drawing/2015/10/21/chartex" xmlns:cx3="http://schemas.microsoft.com/office/drawing/2016/5/9/chartex" xmlns:cx4="http://schemas.microsoft.com/office/drawing/2016/5/10/chartex" xmlns:cx5="http://schemas.microsoft.com/office/drawing/2016/5/11/chartex" xmlns:cx6="http://schemas.microsoft.com/office/drawing/2016/5/12/chartex" xmlns:cx7="http://schemas.microsoft.com/office/drawing/2016/5/13/chartex" xmlns:cx8="http://schemas.microsoft.com/office/drawing/2016/5/14/chartex" xmlns:mc="http://schemas.openxmlformats.org/markup-compatibility/2006" xmlns:aink="http://schemas.microsoft.com/office/drawing/2016/ink" xmlns:am3d="http://schemas.microsoft.com/office/drawing/2017/model3d" xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships" xmlns:m="http://schemas.openxmlformats.org/officeDocument/2006/math" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:wp14="http://schemas.microsoft.com/office/word/2010/wordprocessingDrawing" xmlns:wp="http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing" xmlns:w10="urn:schemas-microsoft-com:office:word" xmlns:w="http://schemas.openxmlformats.org/wordprocessingml/2006/main" xmlns:w14="http://schemas.microsoft.com/office/word/2010/wordml" xmlns:w15="http://schemas.microsoft.com/office/word/2012/wordml" xmlns:w16cex="http://schemas.microsoft.com/office/word/2018/wordml/cex" xmlns:w16cid="http://schemas.microsoft.com/office/word/2016/wordml/cid" xmlns:w16="http://schemas.microsoft.com/office/word/2018/wordml" xmlns:w16sdtdh="http://schemas.microsoft.com/office/word/2020/wordml/sdtdatahash" xmlns:w16se="http://schemas.microsoft.com/office/word/2015/wordml/symex" xmlns:wpg="http://schemas.microsoft.com/office/word/2010/wordprocessingGroup" xmlns:wpi="http://schemas.microsoft.com/office/word/2010/wordprocessingInk" xmlns:wne="http://schemas.microsoft.com/office/word/2006/wordml" xmlns:wps="http://schemas.microsoft.com/office/word/2010/wordprocessingShape" mc:Ignorable="w14 w15 w16se w16cid w16 w16cex w16sdtdh wp14">
        <w:body>
          <w:p w:rsidR="003875DE" w:rsidRDefault="003875DE" w:rsidP="49B28AC9">
            <w:pPr>
              <w:spacing w:line="257" w:lineRule="auto" />
            </w:pPr>
            <w:r w:rsidRPr="76263D19">
              <w:rPr>
                <w:rFonts w:ascii="Calibri" w:eastAsia="Calibri" w:hAnsi="Calibri" w:cs="Calibri" />
                <w:lang w:val="en-US" />
              </w:rPr>
              <w:t xml:space="preserve">Adele Vance is a member of the Contoso corporation. She works in Retail in the US office, her mail’s </w:t>
            </w:r>
            <w:hyperlink r:id="rId4">
              <w:r w:rsidRPr="76263D19">
                <w:rPr>
                  <w:rStyle w:val="Hyperlink" />
                  <w:rFonts w:ascii="Calibri" w:eastAsia="Calibri" w:hAnsi="Calibri" w:cs="Calibri" />
                  <w:lang w:val="en-US" />
                </w:rPr>
                <w:t>adelev@xpectdev.onmicrosoft.com</w:t>
              </w:r>
            </w:hyperlink>
          </w:p>
          <w:p w:rsidR="003875DE" w:rsidRDefault="003875DE" w:rsidP="49B28AC9">
            <w:pPr>
              <w:spacing w:line="257" w:lineRule="auto" />
            </w:pPr>
            <w:r w:rsidRPr="49B28AC9">
              <w:rPr>
                <w:rFonts w:ascii="Calibri" w:eastAsia="Calibri" w:hAnsi="Calibri" w:cs="Calibri" />
                <w:lang w:val="en-US" />
              </w:rPr>
              <w:t xml:space="preserve"></w:t>
            </w:r>
          </w:p>
          <w:p w:rsidR="003875DE" w:rsidRDefault="003875DE" w:rsidP="49B28AC9">
            <w:pPr>
              <w:spacing w:line="257" w:lineRule="auto" />
            </w:pPr>
            <w:r w:rsidRPr="49B28AC9">
              <w:rPr>
                <w:rFonts w:ascii="Calibri" w:eastAsia="Calibri" w:hAnsi="Calibri" w:cs="Calibri" />
                <w:lang w:val="en-US" />
              </w:rPr>
              <w:t xml:space="preserve">Alex Wilber’s office is in the San Diego office. Alex’ phone number is +1 858 555 0110. Miriam Graham, his manager, is also located in San Diego, but her phone number is a little lower, namely +1 858 555 0109. </w:t>
            </w:r>
          </w:p>
          <w:p w:rsidR="003875DE" w:rsidRDefault="003875DE" w:rsidP="49B28AC9">
            <w:pPr>
              <w:spacing w:line="257" w:lineRule="auto" />
            </w:pPr>
            <w:r w:rsidRPr="49B28AC9">
              <w:rPr>
                <w:rFonts w:ascii="Calibri" w:eastAsia="Calibri" w:hAnsi="Calibri" w:cs="Calibri" />
                <w:lang w:val="en-US" />
              </w:rPr>
              <w:t xml:space="preserve">They both work closely with </w:t>
            </w:r>
            <w:hyperlink r:id="rId5">
              <w:r w:rsidRPr="49B28AC9">
                <w:rPr>
                  <w:rStyle w:val="Hyperlink" />
                  <w:rFonts w:ascii="Calibri" w:eastAsia="Calibri" w:hAnsi="Calibri" w:cs="Calibri" />
                  <w:lang w:val="en-US" />
                </w:rPr>
                <w:t>Pradeep</w:t>
              </w:r>
            </w:hyperlink>
            <w:r w:rsidRPr="49B28AC9">
              <w:rPr>
                <w:rFonts w:ascii="Calibri" w:eastAsia="Calibri" w:hAnsi="Calibri" w:cs="Calibri" />
                <w:lang w:val="en-US" />
              </w:rPr>
              <w:t>, and his manager Mr. Wilke from Finance. Their joint project is called “joni”, which is targeted at convincing Joni Sherman to move from the office in the United Stated to the office in Louisville and obtain Patti’s phone number +15025550144.</w:t>
            </w:r>
          </w:p>
          <w:p w:rsidR="003875DE" w:rsidRDefault="003875DE" w:rsidP="49B28AC9" />
          <w:p w:rsidR="003875DE" w:rsidRDefault="003875DE" w:rsidP="49B28AC9" />
          <w:p w:rsidR="003875DE" w:rsidRDefault="003875DE" w:rsidP="49B28AC9">
            <w:pPr>
              <w:spacing w:line="257" w:lineRule="auto" />
            </w:pPr>
            <w:r w:rsidRPr="49B28AC9">
              <w:rPr>
                <w:rFonts w:ascii="Calibri" w:eastAsia="Calibri" w:hAnsi="Calibri" w:cs="Calibri" />
                <w:lang w:val="en-US" />
              </w:rPr>
              <w:t xml:space="preserve">Adel Vance is a member of the Contoso corporation. She works in Retail in the US office, her mail’s </w:t>
            </w:r>
            <w:hyperlink r:id="rId6">
              <w:r w:rsidRPr="49B28AC9">
                <w:rPr>
                  <w:rStyle w:val="Hyperlink" />
                  <w:rFonts w:ascii="Calibri" w:eastAsia="Calibri" w:hAnsi="Calibri" w:cs="Calibri" />
                  <w:lang w:val="en-US" />
                </w:rPr>
                <w:t>adelev@xpectdev.onmicrosoft.com</w:t>
              </w:r>
            </w:hyperlink>
          </w:p>
          <w:p w:rsidR="003875DE" w:rsidRDefault="003875DE" w:rsidP="49B28AC9">
            <w:pPr>
              <w:spacing w:line="257" w:lineRule="auto" />
            </w:pPr>
            <w:r w:rsidRPr="49B28AC9">
              <w:rPr>
                <w:rFonts w:ascii="Calibri" w:eastAsia="Calibri" w:hAnsi="Calibri" w:cs="Calibri" />
                <w:lang w:val="en-US" />
              </w:rPr>
              <w:t xml:space="preserve"></w:t>
            </w:r>
          </w:p>
          <w:p w:rsidR="003875DE" w:rsidRDefault="003875DE" w:rsidP="49B28AC9">
            <w:pPr>
              <w:spacing w:line="257" w:lineRule="auto" />
            </w:pPr>
            <w:r w:rsidRPr="49B28AC9">
              <w:rPr>
                <w:rFonts w:ascii="Calibri" w:eastAsia="Calibri" w:hAnsi="Calibri" w:cs="Calibri" />
                <w:lang w:val="en-US" />
              </w:rPr>
              <w:t xml:space="preserve">Alex Wilber’s office is in the San Diego office. Alex’ phone number is +1 858 555 0110. Miriam Graham, his manager, is also located in San Diego, but her phone number is a little lower, namely +1 858 555 0109. </w:t>
            </w:r>
          </w:p>
          <w:p w:rsidR="003875DE" w:rsidRDefault="003875DE" w:rsidP="49B28AC9">
            <w:pPr>
              <w:spacing w:line="257" w:lineRule="auto" />
            </w:pPr>
            <w:r w:rsidRPr="49B28AC9">
              <w:rPr>
                <w:rFonts w:ascii="Calibri" w:eastAsia="Calibri" w:hAnsi="Calibri" w:cs="Calibri" />
                <w:lang w:val="en-US" />
              </w:rPr>
              <w:t xml:space="preserve">They both work closely with </w:t>
            </w:r>
            <w:hyperlink r:id="rId7">
              <w:r w:rsidRPr="49B28AC9">
                <w:rPr>
                  <w:rStyle w:val="Hyperlink" />
                  <w:rFonts w:ascii="Calibri" w:eastAsia="Calibri" w:hAnsi="Calibri" w:cs="Calibri" />
                  <w:lang w:val="en-US" />
                </w:rPr>
                <w:t>Pradeep</w:t>
              </w:r>
            </w:hyperlink>
            <w:r w:rsidRPr="49B28AC9">
              <w:rPr>
                <w:rFonts w:ascii="Calibri" w:eastAsia="Calibri" w:hAnsi="Calibri" w:cs="Calibri" />
                <w:lang w:val="en-US" />
              </w:rPr>
              <w:t>, and his manager Mr. Wilke from Finance. Their joint project is called “joni”, which is targeted at convincing Joni Sherman to move from the office in the United Stated to the office in Louisville and obtain Patti’s phone number +15025550144.</w:t>
            </w:r>
          </w:p>
          <w:p w:rsidR="003875DE" w:rsidRDefault="003875DE" w:rsidP="49B28AC9" />
          <w:p w:rsidR="003875DE" w:rsidRDefault="003875DE" w:rsidP="49B28AC9" />
          <w:p w:rsidR="003875DE" w:rsidRDefault="003875DE" w:rsidP="49B28AC9">
            <w:pPr>
              <w:spacing w:line="257" w:lineRule="auto" />
            </w:pPr>
            <w:r w:rsidRPr="49B28AC9">
              <w:rPr>
                <w:rFonts w:ascii="Calibri" w:eastAsia="Calibri" w:hAnsi="Calibri" w:cs="Calibri" />
                <w:lang w:val="en-US" />
              </w:rPr>
              <w:t xml:space="preserve">Adel Vance is a member of the Contoso corporation. She works in Retail in the US office, her mail’s </w:t>
            </w:r>
            <w:hyperlink r:id="rId8">
              <w:r w:rsidRPr="49B28AC9">
                <w:rPr>
                  <w:rStyle w:val="Hyperlink" />
                  <w:rFonts w:ascii="Calibri" w:eastAsia="Calibri" w:hAnsi="Calibri" w:cs="Calibri" />
                  <w:lang w:val="en-US" />
                </w:rPr>
                <w:t>adelev@xpectdev.onmicrosoft.com</w:t>
              </w:r>
            </w:hyperlink>
          </w:p>
          <w:p w:rsidR="003875DE" w:rsidRDefault="003875DE" w:rsidP="49B28AC9">
            <w:pPr>
              <w:spacing w:line="257" w:lineRule="auto" />
            </w:pPr>
            <w:r w:rsidRPr="49B28AC9">
              <w:rPr>
                <w:rFonts w:ascii="Calibri" w:eastAsia="Calibri" w:hAnsi="Calibri" w:cs="Calibri" />
                <w:lang w:val="en-US" />
              </w:rPr>
              <w:t xml:space="preserve"></w:t>
            </w:r>
          </w:p>
          <w:p w:rsidR="003875DE" w:rsidRDefault="003875DE" w:rsidP="49B28AC9">
            <w:pPr>
              <w:spacing w:line="257" w:lineRule="auto" />
            </w:pPr>
            <w:r w:rsidRPr="49B28AC9">
              <w:rPr>
                <w:rFonts w:ascii="Calibri" w:eastAsia="Calibri" w:hAnsi="Calibri" w:cs="Calibri" />
                <w:lang w:val="en-US" />
              </w:rPr>
              <w:t xml:space="preserve">Alex Wilber’s office is in the San Diego office. Alex’ phone number is +1 858 555 0110. Miriam Graham, his manager, is also located in San Diego, but her phone number is a little lower, namely +1 858 555 0109. </w:t>
            </w:r>
          </w:p>
          <w:p w:rsidR="003875DE" w:rsidRDefault="003875DE" w:rsidP="49B28AC9">
            <w:pPr>
              <w:spacing w:line="257" w:lineRule="auto" />
            </w:pPr>
            <w:r w:rsidRPr="49B28AC9">
              <w:rPr>
                <w:rFonts w:ascii="Calibri" w:eastAsia="Calibri" w:hAnsi="Calibri" w:cs="Calibri" />
                <w:lang w:val="en-US" />
              </w:rPr>
              <w:t xml:space="preserve">They both work closely with </w:t>
            </w:r>
            <w:hyperlink r:id="rId9">
              <w:r w:rsidRPr="49B28AC9">
                <w:rPr>
                  <w:rStyle w:val="Hyperlink" />
                  <w:rFonts w:ascii="Calibri" w:eastAsia="Calibri" w:hAnsi="Calibri" w:cs="Calibri" />
                  <w:lang w:val="en-US" />
                </w:rPr>
                <w:t>Pradeep</w:t>
              </w:r>
            </w:hyperlink>
            <w:r w:rsidRPr="49B28AC9">
              <w:rPr>
                <w:rFonts w:ascii="Calibri" w:eastAsia="Calibri" w:hAnsi="Calibri" w:cs="Calibri" />
                <w:lang w:val="en-US" />
              </w:rPr>
              <w:t>, and his manager Mr. Wilke from Finance. Their joint project is called “joni”, which is targeted at convincing Joni Sherman to move from the office in the United Stated to the office in Louisville and obtain Patti’s phone number +15025550144.</w:t>
            </w:r>
          </w:p>
          <w:p w:rsidR="003875DE" w:rsidRDefault="003875DE" w:rsidP="49B28AC9" />
          <w:p w:rsidR="003875DE" w:rsidRDefault="003875DE" w:rsidP="49B28AC9" />
          <w:p w:rsidR="00000000" w:rsidRDefault="003875DE" />
          <w:sectPr w:rsidR="00000000">
            <w:pgSz w:w="11906" w:h="16838" />
            <w:pgMar w:top="1440" w:right="1440" w:bottom="1440" w:left="1440" w:header="720" w:footer="720" w:gutter="0" />
            <w:cols w:space="720" />
            <w:docGrid w:linePitch="360" />
          </w:sectPr>
        </w:body>
      </w:document>
    </pkg:xmlData>
  </pkg:part>
  <pkg:part pkg:name="/word/_rels/document.xml.rels" pkg:contentType="application/vnd.openxmlformats-package.relationships+xml" pkg:padding="256">
    <pkg:xmlData>
      <Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">
        <Relationship Id="rId8" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink" Target="mailto:adelev@xpectdev.onmicrosoft.com" TargetMode="External" />
        <Relationship Id="rId3" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/webSettings" Target="webSettings.xml" />
        <Relationship Id="rId7" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink" Target="mailto:PradeepG@xpectdev.onmicrosoft.com" TargetMode="External" />
        <Relationship Id="rId2" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/settings" Target="settings.xml" />
        <Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles" Target="styles.xml" />
        <Relationship Id="rId6" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink" Target="mailto:adelev@xpectdev.onmicrosoft.com" TargetMode="External" />
        <Relationship Id="rId11" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme" Target="theme/theme1.xml" />
        <Relationship Id="rId5" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink" Target="mailto:PradeepG@xpectdev.onmicrosoft.com" TargetMode="External" />
        <Relationship Id="rId10" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/fontTable" Target="fontTable.xml" />
        <Relationship Id="rId4" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink" Target="mailto:adelev@xpectdev.onmicrosoft.com" TargetMode="External" />
        <Relationship Id="rId9" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink" Target="mailto:PradeepG@xpectdev.onmicrosoft.com" TargetMode="External" />
      </Relationships>
    </pkg:xmlData>
  </pkg:part>
  <pkg:part pkg:name="/word/theme/theme1.xml" pkg:contentType="application/vnd.openxmlformats-officedocument.theme+xml">
    <pkg:xmlData>
      <a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme">
        <a:themeElements>
          <a:clrScheme name="Office">
            <a:dk1>
              <a:sysClr val="windowText" lastClr="000000" />
            </a:dk1>
            <a:lt1>
              <a:sysClr val="window" lastClr="FFFFFF" />
            </a:lt1>
            <a:dk2>
              <a:srgbClr val="44546A" />
            </a:dk2>
            <a:lt2>
              <a:srgbClr val="E7E6E6" />
            </a:lt2>
            <a:accent1>
              <a:srgbClr val="4472C4" />
            </a:accent1>
            <a:accent2>
              <a:srgbClr val="ED7D31" />
            </a:accent2>
            <a:accent3>
              <a:srgbClr val="A5A5A5" />
            </a:accent3>
            <a:accent4>
              <a:srgbClr val="FFC000" />
            </a:accent4>
            <a:accent5>
              <a:srgbClr val="5B9BD5" />
            </a:accent5>
            <a:accent6>
              <a:srgbClr val="70AD47" />
            </a:accent6>
            <a:hlink>
              <a:srgbClr val="0563C1" />
            </a:hlink>
            <a:folHlink>
              <a:srgbClr val="954F72" />
            </a:folHlink>
          </a:clrScheme>
          <a:fontScheme name="Office">
            <a:majorFont>
              <a:latin typeface="Calibri Light" panose="020F0302020204030204" />
              <a:ea typeface="" />
              <a:cs typeface="" />
              <a:font script="Jpan" typeface="ＭＳ ゴシック" />
              <a:font script="Hang" typeface="맑은 고딕" />
              <a:font script="Hans" typeface="宋体" />
              <a:font script="Hant" typeface="新細明體" />
              <a:font script="Arab" typeface="Times New Roman" />
              <a:font script="Hebr" typeface="Times New Roman" />
              <a:font script="Thai" typeface="Angsana New" />
              <a:font script="Ethi" typeface="Nyala" />
              <a:font script="Beng" typeface="Vrinda" />
              <a:font script="Gujr" typeface="Shruti" />
              <a:font script="Khmr" typeface="MoolBoran" />
              <a:font script="Knda" typeface="Tunga" />
              <a:font script="Guru" typeface="Raavi" />
              <a:font script="Cans" typeface="Euphemia" />
              <a:font script="Cher" typeface="Plantagenet Cherokee" />
              <a:font script="Yiii" typeface="Microsoft Yi Baiti" />
              <a:font script="Tibt" typeface="Microsoft Himalaya" />
              <a:font script="Thaa" typeface="MV Boli" />
              <a:font script="Deva" typeface="Mangal" />
              <a:font script="Telu" typeface="Gautami" />
              <a:font script="Taml" typeface="Latha" />
              <a:font script="Syrc" typeface="Estrangelo Edessa" />
              <a:font script="Orya" typeface="Kalinga" />
              <a:font script="Mlym" typeface="Kartika" />
              <a:font script="Laoo" typeface="DokChampa" />
              <a:font script="Sinh" typeface="Iskoola Pota" />
              <a:font script="Mong" typeface="Mongolian Baiti" />
              <a:font script="Viet" typeface="Times New Roman" />
              <a:font script="Uigh" typeface="Microsoft Uighur" />
              <a:font script="Geor" typeface="Sylfaen" />
            </a:majorFont>
            <a:minorFont>
              <a:latin typeface="Calibri" panose="020F0502020204030204" />
              <a:ea typeface="" />
              <a:cs typeface="" />
              <a:font script="Jpan" typeface="ＭＳ 明朝" />
              <a:font script="Hang" typeface="맑은 고딕" />
              <a:font script="Hans" typeface="宋体" />
              <a:font script="Hant" typeface="新細明體" />
              <a:font script="Arab" typeface="Arial" />
              <a:font script="Hebr" typeface="Arial" />
              <a:font script="Thai" typeface="Cordia New" />
              <a:font script="Ethi" typeface="Nyala" />
              <a:font script="Beng" typeface="Vrinda" />
              <a:font script="Gujr" typeface="Shruti" />
              <a:font script="Khmr" typeface="DaunPenh" />
              <a:font script="Knda" typeface="Tunga" />
              <a:font script="Guru" typeface="Raavi" />
              <a:font script="Cans" typeface="Euphemia" />
              <a:font script="Cher" typeface="Plantagenet Cherokee" />
              <a:font script="Yiii" typeface="Microsoft Yi Baiti" />
              <a:font script="Tibt" typeface="Microsoft Himalaya" />
              <a:font script="Thaa" typeface="MV Boli" />
              <a:font script="Deva" typeface="Mangal" />
              <a:font script="Telu" typeface="Gautami" />
              <a:font script="Taml" typeface="Latha" />
              <a:font script="Syrc" typeface="Estrangelo Edessa" />
              <a:font script="Orya" typeface="Kalinga" />
              <a:font script="Mlym" typeface="Kartika" />
              <a:font script="Laoo" typeface="DokChampa" />
              <a:font script="Sinh" typeface="Iskoola Pota" />
              <a:font script="Mong" typeface="Mongolian Baiti" />
              <a:font script="Viet" typeface="Arial" />
              <a:font script="Uigh" typeface="Microsoft Uighur" />
              <a:font script="Geor" typeface="Sylfaen" />
            </a:minorFont>
          </a:fontScheme>
          <a:fmtScheme name="Office">
            <a:fillStyleLst>
              <a:solidFill>
                <a:schemeClr val="phClr" />
              </a:solidFill>
              <a:gradFill rotWithShape="1">
                <a:gsLst>
                  <a:gs pos="0">
                    <a:schemeClr val="phClr">
                      <a:lumMod val="110000" />
                      <a:satMod val="105000" />
                      <a:tint val="67000" />
                    </a:schemeClr>
                  </a:gs>
                  <a:gs pos="50000">
                    <a:schemeClr val="phClr">
                      <a:lumMod val="105000" />
                      <a:satMod val="103000" />
                      <a:tint val="73000" />
                    </a:schemeClr>
                  </a:gs>
                  <a:gs pos="100000">
                    <a:schemeClr val="phClr">
                      <a:lumMod val="105000" />
                      <a:satMod val="109000" />
                      <a:tint val="81000" />
                    </a:schemeClr>
                  </a:gs>
                </a:gsLst>
                <a:lin ang="5400000" scaled="0" />
              </a:gradFill>
              <a:gradFill rotWithShape="1">
                <a:gsLst>
                  <a:gs pos="0">
                    <a:schemeClr val="phClr">
                      <a:satMod val="103000" />
                      <a:lumMod val="102000" />
                      <a:tint val="94000" />
                    </a:schemeClr>
                  </a:gs>
                  <a:gs pos="50000">
                    <a:schemeClr val="phClr">
                      <a:satMod val="110000" />
                      <a:lumMod val="100000" />
                      <a:shade val="100000" />
                    </a:schemeClr>
                  </a:gs>
                  <a:gs pos="100000">
                    <a:schemeClr val="phClr">
                      <a:lumMod val="99000" />
                      <a:satMod val="120000" />
                      <a:shade val="78000" />
                    </a:schemeClr>
                  </a:gs>
                </a:gsLst>
                <a:lin ang="5400000" scaled="0" />
              </a:gradFill>
            </a:fillStyleLst>
            <a:lnStyleLst>
              <a:ln w="6350" cap="flat" cmpd="sng" algn="ctr">
                <a:solidFill>
                  <a:schemeClr val="phClr" />
                </a:solidFill>
                <a:prstDash val="solid" />
                <a:miter lim="800000" />
              </a:ln>
              <a:ln w="12700" cap="flat" cmpd="sng" algn="ctr">
                <a:solidFill>
                  <a:schemeClr val="phClr" />
                </a:solidFill>
                <a:prstDash val="solid" />
                <a:miter lim="800000" />
              </a:ln>
              <a:ln w="19050" cap="flat" cmpd="sng" algn="ctr">
                <a:solidFill>
                  <a:schemeClr val="phClr" />
                </a:solidFill>
                <a:prstDash val="solid" />
                <a:miter lim="800000" />
              </a:ln>
            </a:lnStyleLst>
            <a:effectStyleLst>
              <a:effectStyle>
                <a:effectLst />
              </a:effectStyle>
              <a:effectStyle>
                <a:effectLst />
              </a:effectStyle>
              <a:effectStyle>
                <a:effectLst>
                  <a:outerShdw blurRad="57150" dist="19050" dir="5400000" algn="ctr" rotWithShape="0">
                    <a:srgbClr val="000000">
                      <a:alpha val="63000" />
                    </a:srgbClr>
                  </a:outerShdw>
                </a:effectLst>
              </a:effectStyle>
            </a:effectStyleLst>
            <a:bgFillStyleLst>
              <a:solidFill>
                <a:schemeClr val="phClr" />
              </a:solidFill>
              <a:solidFill>
                <a:schemeClr val="phClr">
                  <a:tint val="95000" />
                  <a:satMod val="170000" />
                </a:schemeClr>
              </a:solidFill>
              <a:gradFill rotWithShape="1">
                <a:gsLst>
                  <a:gs pos="0">
                    <a:schemeClr val="phClr">
                      <a:tint val="93000" />
                      <a:satMod val="150000" />
                      <a:shade val="98000" />
                      <a:lumMod val="102000" />
                    </a:schemeClr>
                  </a:gs>
                  <a:gs pos="50000">
                    <a:schemeClr val="phClr">
                      <a:tint val="98000" />
                      <a:satMod val="130000" />
                      <a:shade val="90000" />
                      <a:lumMod val="103000" />
                    </a:schemeClr>
                  </a:gs>
                  <a:gs pos="100000">
                    <a:schemeClr val="phClr">
                      <a:shade val="63000" />
                      <a:satMod val="120000" />
                    </a:schemeClr>
                  </a:gs>
                </a:gsLst>
                <a:lin ang="5400000" scaled="0" />
              </a:gradFill>
            </a:bgFillStyleLst>
          </a:fmtScheme>
        </a:themeElements>
        <a:objectDefaults />
        <a:extraClrSchemeLst />
        <a:extLst>
          <a:ext uri="{05A4C25C-085E-4340-85A3-A5531E510DB2}">
            <thm15:themeFamily xmlns:thm15="http://schemas.microsoft.com/office/thememl/2012/main" name="Office Theme" id="{62F939B6-93AF-4DB8-9C6B-D6C7DFDC589F}" vid="{4A3C46E8-61CC-4603-A589-7422A47A8E4A}" />
          </a:ext>
        </a:extLst>
      </a:theme>
    </pkg:xmlData>
  </pkg:part>
  <pkg:part pkg:name="/word/settings.xml" pkg:contentType="application/vnd.openxmlformats-officedocument.wordprocessingml.settings+xml">
    <pkg:xmlData>
      <w:settings xmlns:mc="http://schemas.openxmlformats.org/markup-compatibility/2006" xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships" xmlns:m="http://schemas.openxmlformats.org/officeDocument/2006/math" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w10="urn:schemas-microsoft-com:office:word" xmlns:w="http://schemas.openxmlformats.org/wordprocessingml/2006/main" xmlns:w14="http://schemas.microsoft.com/office/word/2010/wordml" xmlns:w15="http://schemas.microsoft.com/office/word/2012/wordml" xmlns:w16cex="http://schemas.microsoft.com/office/word/2018/wordml/cex" xmlns:w16cid="http://schemas.microsoft.com/office/word/2016/wordml/cid" xmlns:w16="http://schemas.microsoft.com/office/word/2018/wordml" xmlns:w16sdtdh="http://schemas.microsoft.com/office/word/2020/wordml/sdtdatahash" xmlns:w16se="http://schemas.microsoft.com/office/word/2015/wordml/symex" xmlns:sl="http://schemas.openxmlformats.org/schemaLibrary/2006/main" mc:Ignorable="w14 w15 w16se w16cid w16 w16cex w16sdtdh">
        <w:defaultTabStop w:val="708" />
        <w:hyphenationZone w:val="425" />
        <w:characterSpacingControl w:val="doNotCompress" />
        <w:compat>
          <w:compatSetting w:name="compatibilityMode" w:uri="http://schemas.microsoft.com/office/word" w:val="15" />
          <w:compatSetting w:name="overrideTableStyleFontSizeAndJustification" w:uri="http://schemas.microsoft.com/office/word" w:val="1" />
          <w:compatSetting w:name="enableOpenTypeFeatures" w:uri="http://schemas.microsoft.com/office/word" w:val="1" />
          <w:compatSetting w:name="doNotFlipMirrorIndents" w:uri="http://schemas.microsoft.com/office/word" w:val="1" />
          <w:compatSetting w:name="differentiateMultirowTableHeaders" w:uri="http://schemas.microsoft.com/office/word" w:val="1" />
          <w:compatSetting w:name="useWord2013TrackBottomHyphenation" w:uri="http://schemas.microsoft.com/office/word" w:val="1" />
        </w:compat>
        <w:rsids>
          <w:rsidRoot w:val="5EBBC6F5" />
          <w:rsid w:val="000350E2" />
          <w:rsid w:val="00165336" />
          <w:rsid w:val="001A56A9" />
          <w:rsid w:val="001E215A" />
          <w:rsid w:val="002000C5" />
          <w:rsid w:val="00230560" />
          <w:rsid w:val="00293E42" />
          <w:rsid w:val="00374F3D" />
          <w:rsid w:val="003875DE" />
          <w:rsid w:val="00452C57" />
          <w:rsid w:val="00517AB9" />
          <w:rsid w:val="00593CDF" />
          <w:rsid w:val="005D27E5" />
          <w:rsid w:val="00604803" />
          <w:rsid w:val="00685DC4" />
          <w:rsid w:val="006D6BD3" />
          <w:rsid w:val="00757D6F" />
          <w:rsid w:val="007F614A" />
          <w:rsid w:val="0084101A" />
          <w:rsid w:val="009715E6" />
          <w:rsid w:val="009D0D06" />
          <w:rsid w:val="00A92857" />
          <w:rsid w:val="00A937AF" />
          <w:rsid w:val="00AB51F5" />
          <w:rsid w:val="00AD2A47" />
          <w:rsid w:val="00AF12CF" />
          <w:rsid w:val="00B168F5" />
          <w:rsid w:val="00B72A29" />
          <w:rsid w:val="00BA57E7" />
          <w:rsid w:val="00BEB1CB" />
          <w:rsid w:val="00C22A9E" />
          <w:rsid w:val="00C5285E" />
          <w:rsid w:val="00C7242F" />
          <w:rsid w:val="00E3603F" />
          <w:rsid w:val="00F44CEC" />
          <w:rsid w:val="00F9653A" />
          <w:rsid w:val="0A7E6F55" />
          <w:rsid w:val="49B28AC9" />
          <w:rsid w:val="5EBBC6F5" />
          <w:rsid w:val="76263D19" />
        </w:rsids>
        <m:mathPr>
          <m:mathFont m:val="Cambria Math" />
          <m:brkBin m:val="before" />
          <m:brkBinSub m:val="--" />
          <m:smallFrac m:val="0" />
          <m:dispDef />
          <m:lMargin m:val="0" />
          <m:rMargin m:val="0" />
          <m:defJc m:val="centerGroup" />
          <m:wrapIndent m:val="1440" />
          <m:intLim m:val="subSup" />
          <m:naryLim m:val="undOvr" />
        </m:mathPr>
        <w:themeFontLang w:val="de-DE" w:eastAsia="ja-JP" w:bidi="ar-SA" />
        <w:clrSchemeMapping w:bg1="light1" w:t1="dark1" w:bg2="light2" w:t2="dark2" w:accent1="accent1" w:accent2="accent2" w:accent3="accent3" w:accent4="accent4" w:accent5="accent5" w:accent6="accent6" w:hyperlink="hyperlink" w:followedHyperlink="followedHyperlink" />
        <w:shapeDefaults>
          <o:shapedefaults v:ext="edit" spidmax="1026" />
          <o:shapelayout v:ext="edit">
            <o:idmap v:ext="edit" data="1" />
          </o:shapelayout>
        </w:shapeDefaults>
        <w:decimalSymbol w:val="," />
        <w:listSeparator w:val=";" />
        <w14:docId w14:val="5EBBC6F5" />
        <w15:chartTrackingRefBased />
        <w15:docId w15:val="{52E275E1-FFCF-40CA-AAFE-EC49E698EC13}" />
      </w:settings>
    </pkg:xmlData>
  </pkg:part>
  <pkg:part pkg:name="/word/styles.xml" pkg:contentType="application/vnd.openxmlformats-officedocument.wordprocessingml.styles+xml">
    <pkg:xmlData>
      <w:styles xmlns:mc="http://schemas.openxmlformats.org/markup-compatibility/2006" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships" xmlns:w="http://schemas.openxmlformats.org/wordprocessingml/2006/main" xmlns:w14="http://schemas.microsoft.com/office/word/2010/wordml" xmlns:w15="http://schemas.microsoft.com/office/word/2012/wordml" xmlns:w16cex="http://schemas.microsoft.com/office/word/2018/wordml/cex" xmlns:w16cid="http://schemas.microsoft.com/office/word/2016/wordml/cid" xmlns:w16="http://schemas.microsoft.com/office/word/2018/wordml" xmlns:w16sdtdh="http://schemas.microsoft.com/office/word/2020/wordml/sdtdatahash" xmlns:w16se="http://schemas.microsoft.com/office/word/2015/wordml/symex" mc:Ignorable="w14 w15 w16se w16cid w16 w16cex w16sdtdh">
        <w:docDefaults>
          <w:rPrDefault>
            <w:rPr>
              <w:rFonts w:asciiTheme="minorHAnsi" w:eastAsiaTheme="minorHAnsi" w:hAnsiTheme="minorHAnsi" w:cstheme="minorBidi" />
              <w:sz w:val="22" />
              <w:szCs w:val="22" />
              <w:lang w:val="de-DE" w:eastAsia="en-US" w:bidi="ar-SA" />
            </w:rPr>
          </w:rPrDefault>
          <w:pPrDefault>
            <w:pPr>
              <w:spacing w:after="160" w:line="259" w:lineRule="auto" />
            </w:pPr>
          </w:pPrDefault>
        </w:docDefaults>
        <w:latentStyles w:defLockedState="0" w:defUIPriority="99" w:defSemiHidden="0" w:defUnhideWhenUsed="0" w:defQFormat="0" w:count="376">
          <w:lsdException w:name="Normal" w:uiPriority="0" w:qFormat="1" />
          <w:lsdException w:name="heading 1" w:uiPriority="9" w:qFormat="1" />
          <w:lsdException w:name="heading 2" w:semiHidden="1" w:uiPriority="9" w:unhideWhenUsed="1" w:qFormat="1" />
          <w:lsdException w:name="heading 3" w:semiHidden="1" w:uiPriority="9" w:unhideWhenUsed="1" w:qFormat="1" />
          <w:lsdException w:name="heading 4" w:semiHidden="1" w:uiPriority="9" w:unhideWhenUsed="1" w:qFormat="1" />
          <w:lsdException w:name="heading 5" w:semiHidden="1" w:uiPriority="9" w:unhideWhenUsed="1" w:qFormat="1" />
          <w:lsdException w:name="heading 6" w:semiHidden="1" w:uiPriority="9" w:unhideWhenUsed="1" w:qFormat="1" />
          <w:lsdException w:name="heading 7" w:semiHidden="1" w:uiPriority="9" w:unhideWhenUsed="1" w:qFormat="1" />
          <w:lsdException w:name="heading 8" w:semiHidden="1" w:uiPriority="9" w:unhideWhenUsed="1" w:qFormat="1" />
          <w:lsdException w:name="heading 9" w:semiHidden="1" w:uiPriority="9" w:unhideWhenUsed="1" w:qFormat="1" />
          <w:lsdException w:name="index 1" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="index 2" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="index 3" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="index 4" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="index 5" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="index 6" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="index 7" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="index 8" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="index 9" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="toc 1" w:semiHidden="1" w:uiPriority="39" w:unhideWhenUsed="1" />
          <w:lsdException w:name="toc 2" w:semiHidden="1" w:uiPriority="39" w:unhideWhenUsed="1" />
          <w:lsdException w:name="toc 3" w:semiHidden="1" w:uiPriority="39" w:unhideWhenUsed="1" />
          <w:lsdException w:name="toc 4" w:semiHidden="1" w:uiPriority="39" w:unhideWhenUsed="1" />
          <w:lsdException w:name="toc 5" w:semiHidden="1" w:uiPriority="39" w:unhideWhenUsed="1" />
          <w:lsdException w:name="toc 6" w:semiHidden="1" w:uiPriority="39" w:unhideWhenUsed="1" />
          <w:lsdException w:name="toc 7" w:semiHidden="1" w:uiPriority="39" w:unhideWhenUsed="1" />
          <w:lsdException w:name="toc 8" w:semiHidden="1" w:uiPriority="39" w:unhideWhenUsed="1" />
          <w:lsdException w:name="toc 9" w:semiHidden="1" w:uiPriority="39" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Normal Indent" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="footnote text" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="annotation text" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="header" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="footer" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="index heading" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="caption" w:semiHidden="1" w:uiPriority="35" w:unhideWhenUsed="1" w:qFormat="1" />
          <w:lsdException w:name="table of figures" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="envelope address" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="envelope return" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="footnote reference" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="annotation reference" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="line number" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="page number" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="endnote reference" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="endnote text" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="table of authorities" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="macro" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="toa heading" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="List" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="List Bullet" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="List Number" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="List 2" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="List 3" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="List 4" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="List 5" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="List Bullet 2" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="List Bullet 3" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="List Bullet 4" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="List Bullet 5" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="List Number 2" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="List Number 3" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="List Number 4" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="List Number 5" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Title" w:uiPriority="10" w:qFormat="1" />
          <w:lsdException w:name="Closing" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Signature" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Default Paragraph Font" w:semiHidden="1" w:uiPriority="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Body Text" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Body Text Indent" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="List Continue" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="List Continue 2" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="List Continue 3" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="List Continue 4" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="List Continue 5" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Message Header" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Subtitle" w:uiPriority="11" w:qFormat="1" />
          <w:lsdException w:name="Salutation" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Date" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Body Text First Indent" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Body Text First Indent 2" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Note Heading" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Body Text 2" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Body Text 3" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Body Text Indent 2" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Body Text Indent 3" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Block Text" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Hyperlink" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="FollowedHyperlink" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Strong" w:uiPriority="22" w:qFormat="1" />
          <w:lsdException w:name="Emphasis" w:uiPriority="20" w:qFormat="1" />
          <w:lsdException w:name="Document Map" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Plain Text" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="E-mail Signature" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="HTML Top of Form" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="HTML Bottom of Form" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Normal (Web)" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="HTML Acronym" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="HTML Address" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="HTML Cite" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="HTML Code" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="HTML Definition" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="HTML Keyboard" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="HTML Preformatted" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="HTML Sample" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="HTML Typewriter" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="HTML Variable" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Normal Table" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="annotation subject" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="No List" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Outline List 1" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Outline List 2" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Outline List 3" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Table Simple 1" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Table Simple 2" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Table Simple 3" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Table Classic 1" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Table Classic 2" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Table Classic 3" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Table Classic 4" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Table Colorful 1" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Table Colorful 2" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Table Colorful 3" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Table Columns 1" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Table Columns 2" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Table Columns 3" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Table Columns 4" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Table Columns 5" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Table Grid 1" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Table Grid 2" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Table Grid 3" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Table Grid 4" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Table Grid 5" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Table Grid 6" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Table Grid 7" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Table Grid 8" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Table List 1" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Table List 2" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Table List 3" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Table List 4" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Table List 5" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Table List 6" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Table List 7" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Table List 8" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Table 3D effects 1" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Table 3D effects 2" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Table 3D effects 3" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Table Contemporary" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Table Elegant" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Table Professional" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Table Subtle 1" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Table Subtle 2" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Table Web 1" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Table Web 2" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Table Web 3" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Balloon Text" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Table Grid" w:uiPriority="39" />
          <w:lsdException w:name="Table Theme" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Placeholder Text" w:semiHidden="1" />
          <w:lsdException w:name="No Spacing" w:uiPriority="1" w:qFormat="1" />
          <w:lsdException w:name="Light Shading" w:uiPriority="60" />
          <w:lsdException w:name="Light List" w:uiPriority="61" />
          <w:lsdException w:name="Light Grid" w:uiPriority="62" />
          <w:lsdException w:name="Medium Shading 1" w:uiPriority="63" />
          <w:lsdException w:name="Medium Shading 2" w:uiPriority="64" />
          <w:lsdException w:name="Medium List 1" w:uiPriority="65" />
          <w:lsdException w:name="Medium List 2" w:uiPriority="66" />
          <w:lsdException w:name="Medium Grid 1" w:uiPriority="67" />
          <w:lsdException w:name="Medium Grid 2" w:uiPriority="68" />
          <w:lsdException w:name="Medium Grid 3" w:uiPriority="69" />
          <w:lsdException w:name="Dark List" w:uiPriority="70" />
          <w:lsdException w:name="Colorful Shading" w:uiPriority="71" />
          <w:lsdException w:name="Colorful List" w:uiPriority="72" />
          <w:lsdException w:name="Colorful Grid" w:uiPriority="73" />
          <w:lsdException w:name="Light Shading Accent 1" w:uiPriority="60" />
          <w:lsdException w:name="Light List Accent 1" w:uiPriority="61" />
          <w:lsdException w:name="Light Grid Accent 1" w:uiPriority="62" />
          <w:lsdException w:name="Medium Shading 1 Accent 1" w:uiPriority="63" />
          <w:lsdException w:name="Medium Shading 2 Accent 1" w:uiPriority="64" />
          <w:lsdException w:name="Medium List 1 Accent 1" w:uiPriority="65" />
          <w:lsdException w:name="Revision" w:semiHidden="1" />
          <w:lsdException w:name="List Paragraph" w:uiPriority="34" w:qFormat="1" />
          <w:lsdException w:name="Quote" w:uiPriority="29" w:qFormat="1" />
          <w:lsdException w:name="Intense Quote" w:uiPriority="30" w:qFormat="1" />
          <w:lsdException w:name="Medium List 2 Accent 1" w:uiPriority="66" />
          <w:lsdException w:name="Medium Grid 1 Accent 1" w:uiPriority="67" />
          <w:lsdException w:name="Medium Grid 2 Accent 1" w:uiPriority="68" />
          <w:lsdException w:name="Medium Grid 3 Accent 1" w:uiPriority="69" />
          <w:lsdException w:name="Dark List Accent 1" w:uiPriority="70" />
          <w:lsdException w:name="Colorful Shading Accent 1" w:uiPriority="71" />
          <w:lsdException w:name="Colorful List Accent 1" w:uiPriority="72" />
          <w:lsdException w:name="Colorful Grid Accent 1" w:uiPriority="73" />
          <w:lsdException w:name="Light Shading Accent 2" w:uiPriority="60" />
          <w:lsdException w:name="Light List Accent 2" w:uiPriority="61" />
          <w:lsdException w:name="Light Grid Accent 2" w:uiPriority="62" />
          <w:lsdException w:name="Medium Shading 1 Accent 2" w:uiPriority="63" />
          <w:lsdException w:name="Medium Shading 2 Accent 2" w:uiPriority="64" />
          <w:lsdException w:name="Medium List 1 Accent 2" w:uiPriority="65" />
          <w:lsdException w:name="Medium List 2 Accent 2" w:uiPriority="66" />
          <w:lsdException w:name="Medium Grid 1 Accent 2" w:uiPriority="67" />
          <w:lsdException w:name="Medium Grid 2 Accent 2" w:uiPriority="68" />
          <w:lsdException w:name="Medium Grid 3 Accent 2" w:uiPriority="69" />
          <w:lsdException w:name="Dark List Accent 2" w:uiPriority="70" />
          <w:lsdException w:name="Colorful Shading Accent 2" w:uiPriority="71" />
          <w:lsdException w:name="Colorful List Accent 2" w:uiPriority="72" />
          <w:lsdException w:name="Colorful Grid Accent 2" w:uiPriority="73" />
          <w:lsdException w:name="Light Shading Accent 3" w:uiPriority="60" />
          <w:lsdException w:name="Light List Accent 3" w:uiPriority="61" />
          <w:lsdException w:name="Light Grid Accent 3" w:uiPriority="62" />
          <w:lsdException w:name="Medium Shading 1 Accent 3" w:uiPriority="63" />
          <w:lsdException w:name="Medium Shading 2 Accent 3" w:uiPriority="64" />
          <w:lsdException w:name="Medium List 1 Accent 3" w:uiPriority="65" />
          <w:lsdException w:name="Medium List 2 Accent 3" w:uiPriority="66" />
          <w:lsdException w:name="Medium Grid 1 Accent 3" w:uiPriority="67" />
          <w:lsdException w:name="Medium Grid 2 Accent 3" w:uiPriority="68" />
          <w:lsdException w:name="Medium Grid 3 Accent 3" w:uiPriority="69" />
          <w:lsdException w:name="Dark List Accent 3" w:uiPriority="70" />
          <w:lsdException w:name="Colorful Shading Accent 3" w:uiPriority="71" />
          <w:lsdException w:name="Colorful List Accent 3" w:uiPriority="72" />
          <w:lsdException w:name="Colorful Grid Accent 3" w:uiPriority="73" />
          <w:lsdException w:name="Light Shading Accent 4" w:uiPriority="60" />
          <w:lsdException w:name="Light List Accent 4" w:uiPriority="61" />
          <w:lsdException w:name="Light Grid Accent 4" w:uiPriority="62" />
          <w:lsdException w:name="Medium Shading 1 Accent 4" w:uiPriority="63" />
          <w:lsdException w:name="Medium Shading 2 Accent 4" w:uiPriority="64" />
          <w:lsdException w:name="Medium List 1 Accent 4" w:uiPriority="65" />
          <w:lsdException w:name="Medium List 2 Accent 4" w:uiPriority="66" />
          <w:lsdException w:name="Medium Grid 1 Accent 4" w:uiPriority="67" />
          <w:lsdException w:name="Medium Grid 2 Accent 4" w:uiPriority="68" />
          <w:lsdException w:name="Medium Grid 3 Accent 4" w:uiPriority="69" />
          <w:lsdException w:name="Dark List Accent 4" w:uiPriority="70" />
          <w:lsdException w:name="Colorful Shading Accent 4" w:uiPriority="71" />
          <w:lsdException w:name="Colorful List Accent 4" w:uiPriority="72" />
          <w:lsdException w:name="Colorful Grid Accent 4" w:uiPriority="73" />
          <w:lsdException w:name="Light Shading Accent 5" w:uiPriority="60" />
          <w:lsdException w:name="Light List Accent 5" w:uiPriority="61" />
          <w:lsdException w:name="Light Grid Accent 5" w:uiPriority="62" />
          <w:lsdException w:name="Medium Shading 1 Accent 5" w:uiPriority="63" />
          <w:lsdException w:name="Medium Shading 2 Accent 5" w:uiPriority="64" />
          <w:lsdException w:name="Medium List 1 Accent 5" w:uiPriority="65" />
          <w:lsdException w:name="Medium List 2 Accent 5" w:uiPriority="66" />
          <w:lsdException w:name="Medium Grid 1 Accent 5" w:uiPriority="67" />
          <w:lsdException w:name="Medium Grid 2 Accent 5" w:uiPriority="68" />
          <w:lsdException w:name="Medium Grid 3 Accent 5" w:uiPriority="69" />
          <w:lsdException w:name="Dark List Accent 5" w:uiPriority="70" />
          <w:lsdException w:name="Colorful Shading Accent 5" w:uiPriority="71" />
          <w:lsdException w:name="Colorful List Accent 5" w:uiPriority="72" />
          <w:lsdException w:name="Colorful Grid Accent 5" w:uiPriority="73" />
          <w:lsdException w:name="Light Shading Accent 6" w:uiPriority="60" />
          <w:lsdException w:name="Light List Accent 6" w:uiPriority="61" />
          <w:lsdException w:name="Light Grid Accent 6" w:uiPriority="62" />
          <w:lsdException w:name="Medium Shading 1 Accent 6" w:uiPriority="63" />
          <w:lsdException w:name="Medium Shading 2 Accent 6" w:uiPriority="64" />
          <w:lsdException w:name="Medium List 1 Accent 6" w:uiPriority="65" />
          <w:lsdException w:name="Medium List 2 Accent 6" w:uiPriority="66" />
          <w:lsdException w:name="Medium Grid 1 Accent 6" w:uiPriority="67" />
          <w:lsdException w:name="Medium Grid 2 Accent 6" w:uiPriority="68" />
          <w:lsdException w:name="Medium Grid 3 Accent 6" w:uiPriority="69" />
          <w:lsdException w:name="Dark List Accent 6" w:uiPriority="70" />
          <w:lsdException w:name="Colorful Shading Accent 6" w:uiPriority="71" />
          <w:lsdException w:name="Colorful List Accent 6" w:uiPriority="72" />
          <w:lsdException w:name="Colorful Grid Accent 6" w:uiPriority="73" />
          <w:lsdException w:name="Subtle Emphasis" w:uiPriority="19" w:qFormat="1" />
          <w:lsdException w:name="Intense Emphasis" w:uiPriority="21" w:qFormat="1" />
          <w:lsdException w:name="Subtle Reference" w:uiPriority="31" w:qFormat="1" />
          <w:lsdException w:name="Intense Reference" w:uiPriority="32" w:qFormat="1" />
          <w:lsdException w:name="Book Title" w:uiPriority="33" w:qFormat="1" />
          <w:lsdException w:name="Bibliography" w:semiHidden="1" w:uiPriority="37" w:unhideWhenUsed="1" />
          <w:lsdException w:name="TOC Heading" w:semiHidden="1" w:uiPriority="39" w:unhideWhenUsed="1" w:qFormat="1" />
          <w:lsdException w:name="Plain Table 1" w:uiPriority="41" />
          <w:lsdException w:name="Plain Table 2" w:uiPriority="42" />
          <w:lsdException w:name="Plain Table 3" w:uiPriority="43" />
          <w:lsdException w:name="Plain Table 4" w:uiPriority="44" />
          <w:lsdException w:name="Plain Table 5" w:uiPriority="45" />
          <w:lsdException w:name="Grid Table Light" w:uiPriority="40" />
          <w:lsdException w:name="Grid Table 1 Light" w:uiPriority="46" />
          <w:lsdException w:name="Grid Table 2" w:uiPriority="47" />
          <w:lsdException w:name="Grid Table 3" w:uiPriority="48" />
          <w:lsdException w:name="Grid Table 4" w:uiPriority="49" />
          <w:lsdException w:name="Grid Table 5 Dark" w:uiPriority="50" />
          <w:lsdException w:name="Grid Table 6 Colorful" w:uiPriority="51" />
          <w:lsdException w:name="Grid Table 7 Colorful" w:uiPriority="52" />
          <w:lsdException w:name="Grid Table 1 Light Accent 1" w:uiPriority="46" />
          <w:lsdException w:name="Grid Table 2 Accent 1" w:uiPriority="47" />
          <w:lsdException w:name="Grid Table 3 Accent 1" w:uiPriority="48" />
          <w:lsdException w:name="Grid Table 4 Accent 1" w:uiPriority="49" />
          <w:lsdException w:name="Grid Table 5 Dark Accent 1" w:uiPriority="50" />
          <w:lsdException w:name="Grid Table 6 Colorful Accent 1" w:uiPriority="51" />
          <w:lsdException w:name="Grid Table 7 Colorful Accent 1" w:uiPriority="52" />
          <w:lsdException w:name="Grid Table 1 Light Accent 2" w:uiPriority="46" />
          <w:lsdException w:name="Grid Table 2 Accent 2" w:uiPriority="47" />
          <w:lsdException w:name="Grid Table 3 Accent 2" w:uiPriority="48" />
          <w:lsdException w:name="Grid Table 4 Accent 2" w:uiPriority="49" />
          <w:lsdException w:name="Grid Table 5 Dark Accent 2" w:uiPriority="50" />
          <w:lsdException w:name="Grid Table 6 Colorful Accent 2" w:uiPriority="51" />
          <w:lsdException w:name="Grid Table 7 Colorful Accent 2" w:uiPriority="52" />
          <w:lsdException w:name="Grid Table 1 Light Accent 3" w:uiPriority="46" />
          <w:lsdException w:name="Grid Table 2 Accent 3" w:uiPriority="47" />
          <w:lsdException w:name="Grid Table 3 Accent 3" w:uiPriority="48" />
          <w:lsdException w:name="Grid Table 4 Accent 3" w:uiPriority="49" />
          <w:lsdException w:name="Grid Table 5 Dark Accent 3" w:uiPriority="50" />
          <w:lsdException w:name="Grid Table 6 Colorful Accent 3" w:uiPriority="51" />
          <w:lsdException w:name="Grid Table 7 Colorful Accent 3" w:uiPriority="52" />
          <w:lsdException w:name="Grid Table 1 Light Accent 4" w:uiPriority="46" />
          <w:lsdException w:name="Grid Table 2 Accent 4" w:uiPriority="47" />
          <w:lsdException w:name="Grid Table 3 Accent 4" w:uiPriority="48" />
          <w:lsdException w:name="Grid Table 4 Accent 4" w:uiPriority="49" />
          <w:lsdException w:name="Grid Table 5 Dark Accent 4" w:uiPriority="50" />
          <w:lsdException w:name="Grid Table 6 Colorful Accent 4" w:uiPriority="51" />
          <w:lsdException w:name="Grid Table 7 Colorful Accent 4" w:uiPriority="52" />
          <w:lsdException w:name="Grid Table 1 Light Accent 5" w:uiPriority="46" />
          <w:lsdException w:name="Grid Table 2 Accent 5" w:uiPriority="47" />
          <w:lsdException w:name="Grid Table 3 Accent 5" w:uiPriority="48" />
          <w:lsdException w:name="Grid Table 4 Accent 5" w:uiPriority="49" />
          <w:lsdException w:name="Grid Table 5 Dark Accent 5" w:uiPriority="50" />
          <w:lsdException w:name="Grid Table 6 Colorful Accent 5" w:uiPriority="51" />
          <w:lsdException w:name="Grid Table 7 Colorful Accent 5" w:uiPriority="52" />
          <w:lsdException w:name="Grid Table 1 Light Accent 6" w:uiPriority="46" />
          <w:lsdException w:name="Grid Table 2 Accent 6" w:uiPriority="47" />
          <w:lsdException w:name="Grid Table 3 Accent 6" w:uiPriority="48" />
          <w:lsdException w:name="Grid Table 4 Accent 6" w:uiPriority="49" />
          <w:lsdException w:name="Grid Table 5 Dark Accent 6" w:uiPriority="50" />
          <w:lsdException w:name="Grid Table 6 Colorful Accent 6" w:uiPriority="51" />
          <w:lsdException w:name="Grid Table 7 Colorful Accent 6" w:uiPriority="52" />
          <w:lsdException w:name="List Table 1 Light" w:uiPriority="46" />
          <w:lsdException w:name="List Table 2" w:uiPriority="47" />
          <w:lsdException w:name="List Table 3" w:uiPriority="48" />
          <w:lsdException w:name="List Table 4" w:uiPriority="49" />
          <w:lsdException w:name="List Table 5 Dark" w:uiPriority="50" />
          <w:lsdException w:name="List Table 6 Colorful" w:uiPriority="51" />
          <w:lsdException w:name="List Table 7 Colorful" w:uiPriority="52" />
          <w:lsdException w:name="List Table 1 Light Accent 1" w:uiPriority="46" />
          <w:lsdException w:name="List Table 2 Accent 1" w:uiPriority="47" />
          <w:lsdException w:name="List Table 3 Accent 1" w:uiPriority="48" />
          <w:lsdException w:name="List Table 4 Accent 1" w:uiPriority="49" />
          <w:lsdException w:name="List Table 5 Dark Accent 1" w:uiPriority="50" />
          <w:lsdException w:name="List Table 6 Colorful Accent 1" w:uiPriority="51" />
          <w:lsdException w:name="List Table 7 Colorful Accent 1" w:uiPriority="52" />
          <w:lsdException w:name="List Table 1 Light Accent 2" w:uiPriority="46" />
          <w:lsdException w:name="List Table 2 Accent 2" w:uiPriority="47" />
          <w:lsdException w:name="List Table 3 Accent 2" w:uiPriority="48" />
          <w:lsdException w:name="List Table 4 Accent 2" w:uiPriority="49" />
          <w:lsdException w:name="List Table 5 Dark Accent 2" w:uiPriority="50" />
          <w:lsdException w:name="List Table 6 Colorful Accent 2" w:uiPriority="51" />
          <w:lsdException w:name="List Table 7 Colorful Accent 2" w:uiPriority="52" />
          <w:lsdException w:name="List Table 1 Light Accent 3" w:uiPriority="46" />
          <w:lsdException w:name="List Table 2 Accent 3" w:uiPriority="47" />
          <w:lsdException w:name="List Table 3 Accent 3" w:uiPriority="48" />
          <w:lsdException w:name="List Table 4 Accent 3" w:uiPriority="49" />
          <w:lsdException w:name="List Table 5 Dark Accent 3" w:uiPriority="50" />
          <w:lsdException w:name="List Table 6 Colorful Accent 3" w:uiPriority="51" />
          <w:lsdException w:name="List Table 7 Colorful Accent 3" w:uiPriority="52" />
          <w:lsdException w:name="List Table 1 Light Accent 4" w:uiPriority="46" />
          <w:lsdException w:name="List Table 2 Accent 4" w:uiPriority="47" />
          <w:lsdException w:name="List Table 3 Accent 4" w:uiPriority="48" />
          <w:lsdException w:name="List Table 4 Accent 4" w:uiPriority="49" />
          <w:lsdException w:name="List Table 5 Dark Accent 4" w:uiPriority="50" />
          <w:lsdException w:name="List Table 6 Colorful Accent 4" w:uiPriority="51" />
          <w:lsdException w:name="List Table 7 Colorful Accent 4" w:uiPriority="52" />
          <w:lsdException w:name="List Table 1 Light Accent 5" w:uiPriority="46" />
          <w:lsdException w:name="List Table 2 Accent 5" w:uiPriority="47" />
          <w:lsdException w:name="List Table 3 Accent 5" w:uiPriority="48" />
          <w:lsdException w:name="List Table 4 Accent 5" w:uiPriority="49" />
          <w:lsdException w:name="List Table 5 Dark Accent 5" w:uiPriority="50" />
          <w:lsdException w:name="List Table 6 Colorful Accent 5" w:uiPriority="51" />
          <w:lsdException w:name="List Table 7 Colorful Accent 5" w:uiPriority="52" />
          <w:lsdException w:name="List Table 1 Light Accent 6" w:uiPriority="46" />
          <w:lsdException w:name="List Table 2 Accent 6" w:uiPriority="47" />
          <w:lsdException w:name="List Table 3 Accent 6" w:uiPriority="48" />
          <w:lsdException w:name="List Table 4 Accent 6" w:uiPriority="49" />
          <w:lsdException w:name="List Table 5 Dark Accent 6" w:uiPriority="50" />
          <w:lsdException w:name="List Table 6 Colorful Accent 6" w:uiPriority="51" />
          <w:lsdException w:name="List Table 7 Colorful Accent 6" w:uiPriority="52" />
          <w:lsdException w:name="Mention" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Smart Hyperlink" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Hashtag" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Unresolved Mention" w:semiHidden="1" w:unhideWhenUsed="1" />
          <w:lsdException w:name="Smart Link" w:semiHidden="1" w:unhideWhenUsed="1" />
        </w:latentStyles>
        <w:style w:type="paragraph" w:default="1" w:styleId="Standard">
          <w:name w:val="Normal" />
          <w:qFormat />
        </w:style>
        <w:style w:type="character" w:default="1" w:styleId="Absatz-Standardschriftart">
          <w:name w:val="Default Paragraph Font" />
          <w:uiPriority w:val="1" />
          <w:semiHidden />
          <w:unhideWhenUsed />
        </w:style>
        <w:style w:type="table" w:default="1" w:styleId="NormaleTabelle">
          <w:name w:val="Normal Table" />
          <w:uiPriority w:val="99" />
          <w:semiHidden />
          <w:unhideWhenUsed />
          <w:tblPr>
            <w:tblInd w:w="0" w:type="dxa" />
            <w:tblCellMar>
              <w:top w:w="0" w:type="dxa" />
              <w:left w:w="108" w:type="dxa" />
              <w:bottom w:w="0" w:type="dxa" />
              <w:right w:w="108" w:type="dxa" />
            </w:tblCellMar>
          </w:tblPr>
        </w:style>
        <w:style w:type="numbering" w:default="1" w:styleId="KeineListe">
          <w:name w:val="No List" />
          <w:uiPriority w:val="99" />
          <w:semiHidden />
          <w:unhideWhenUsed />
        </w:style>
        <w:style w:type="character" w:styleId="Hyperlink">
          <w:name w:val="Hyperlink" />
          <w:basedOn w:val="Absatz-Standardschriftart" />
          <w:uiPriority w:val="99" />
          <w:unhideWhenUsed />
          <w:rPr>
            <w:color w:val="0563C1" w:themeColor="hyperlink" />
            <w:u w:val="single" />
          </w:rPr>
        </w:style>
      </w:styles>
    </pkg:xmlData>
  </pkg:part>
  <pkg:part pkg:name="/word/webSettings.xml" pkg:contentType="application/vnd.openxmlformats-officedocument.wordprocessingml.webSettings+xml">
    <pkg:xmlData>
      <w:webSettings xmlns:mc="http://schemas.openxmlformats.org/markup-compatibility/2006" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships" xmlns:w="http://schemas.openxmlformats.org/wordprocessingml/2006/main" xmlns:w14="http://schemas.microsoft.com/office/word/2010/wordml" xmlns:w15="http://schemas.microsoft.com/office/word/2012/wordml" xmlns:w16cex="http://schemas.microsoft.com/office/word/2018/wordml/cex" xmlns:w16cid="http://schemas.microsoft.com/office/word/2016/wordml/cid" xmlns:w16="http://schemas.microsoft.com/office/word/2018/wordml" xmlns:w16sdtdh="http://schemas.microsoft.com/office/word/2020/wordml/sdtdatahash" xmlns:w16se="http://schemas.microsoft.com/office/word/2015/wordml/symex" mc:Ignorable="w14 w15 w16se w16cid w16 w16cex w16sdtdh">
        <w:optimizeForBrowser />
        <w:allowPNG />
      </w:webSettings>
    </pkg:xmlData>
  </pkg:part>
  <pkg:part pkg:name="/word/fontTable.xml" pkg:contentType="application/vnd.openxmlformats-officedocument.wordprocessingml.fontTable+xml">
    <pkg:xmlData>
      <w:fonts xmlns:mc="http://schemas.openxmlformats.org/markup-compatibility/2006" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships" xmlns:w="http://schemas.openxmlformats.org/wordprocessingml/2006/main" xmlns:w14="http://schemas.microsoft.com/office/word/2010/wordml" xmlns:w15="http://schemas.microsoft.com/office/word/2012/wordml" xmlns:w16cex="http://schemas.microsoft.com/office/word/2018/wordml/cex" xmlns:w16cid="http://schemas.microsoft.com/office/word/2016/wordml/cid" xmlns:w16="http://schemas.microsoft.com/office/word/2018/wordml" xmlns:w16sdtdh="http://schemas.microsoft.com/office/word/2020/wordml/sdtdatahash" xmlns:w16se="http://schemas.microsoft.com/office/word/2015/wordml/symex" mc:Ignorable="w14 w15 w16se w16cid w16 w16cex w16sdtdh">
        <w:font w:name="Calibri">
          <w:panose1 w:val="020F0502020204030204" />
          <w:charset w:val="00" />
          <w:family w:val="swiss" />
          <w:pitch w:val="variable" />
          <w:sig w:usb0="E4002EFF" w:usb1="C000247B" w:usb2="00000009" w:usb3="00000000" w:csb0="000001FF" w:csb1="00000000" />
        </w:font>
        <w:font w:name="Arial">
          <w:panose1 w:val="020B0604020202020204" />
          <w:charset w:val="00" />
          <w:family w:val="swiss" />
          <w:pitch w:val="variable" />
          <w:sig w:usb0="E0002EFF" w:usb1="C000785B" w:usb2="00000009" w:usb3="00000000" w:csb0="000001FF" w:csb1="00000000" />
        </w:font>
        <w:font w:name="Times New Roman">
          <w:panose1 w:val="02020603050405020304" />
          <w:charset w:val="00" />
          <w:family w:val="roman" />
          <w:pitch w:val="variable" />
          <w:sig w:usb0="E0002EFF" w:usb1="C000785B" w:usb2="00000009" w:usb3="00000000" w:csb0="000001FF" w:csb1="00000000" />
        </w:font>
        <w:font w:name="MS Gothic">
          <w:altName w:val="ＭＳ ゴシック" />
          <w:panose1 w:val="020B0609070205080204" />
          <w:charset w:val="80" />
          <w:family w:val="modern" />
          <w:pitch w:val="fixed" />
          <w:sig w:usb0="E00002FF" w:usb1="6AC7FDFB" w:usb2="08000012" w:usb3="00000000" w:csb0="0002009F" w:csb1="00000000" />
        </w:font>
        <w:font w:name="Calibri Light">
          <w:panose1 w:val="020F0302020204030204" />
          <w:charset w:val="00" />
          <w:family w:val="swiss" />
          <w:pitch w:val="variable" />
          <w:sig w:usb0="E4002EFF" w:usb1="C000247B" w:usb2="00000009" w:usb3="00000000" w:csb0="000001FF" w:csb1="00000000" />
        </w:font>
        <w:font w:name="MS Mincho">
          <w:altName w:val="ＭＳ 明朝" />
          <w:panose1 w:val="02020609040205080304" />
          <w:charset w:val="80" />
          <w:family w:val="modern" />
          <w:pitch w:val="fixed" />
          <w:sig w:usb0="E00002FF" w:usb1="6AC7FDFB" w:usb2="08000012" w:usb3="00000000" w:csb0="0002009F" w:csb1="00000000" />
        </w:font>
      </w:fonts>
    </pkg:xmlData>
  </pkg:part>
</pkg:package>` as string
